import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { ScanStockUnitPage } from "./pages";

export const StockScansRouter = [
  <Route
    path="/stock-scan"
    element={
      <ProtectedRoute roles={["Any"]}>
        <ScanStockUnitPage />
      </ProtectedRoute>
    }
  />,
];
